import Bowser from 'bowser';
import REGION_CODES from '../../paperworkRegions'; 

const FORM_PPI = 254;
const INCHES_PER_CM = 2.54;
const userAgent = Bowser.parse(window.navigator.userAgent);

var constants = {
    KEY_GROUP_ARROWS: [37, 38, 39, 40],
    KEY_GROUP_DELETE: [8, 46],
    KEY_ENTER: 13,
    KEY_ESCAPE: 27,
    KEY_EQUAL: 187,
    KEY_MINUS: 189,
    KEY_PLUS: 187,
    KEY_ZERO: 48,
    KEY_UP: 38,
    KEY_DOWN: 40,
    KEY_LEFT: 37,
    KEY_RIGHT: 39,
    KEY_SPACE: 32,
    KEY_TAB: 9,
    KEY_SHIFT: 16,
    KEY_CTRL: 17,
    KEY_META: 224,
    KEY_ALT: 18,
    KEY_HOME: 36,
    KEY_END: 35,
    KEY_A: 65,
    KEY_C: 67,
    KEY_V: 86,
    KEY_Z: 90,
    BUTTON_MOUSE_LEFT: 0,
    PAGE_SIZES: {
        letter: {
            width: 2159,
            height: 2794,
            title: 'US Letter'
        },
        legal: {
            width: 2159,
            height: 3556,
            title: 'US Legal'
        },
        a4: {
            width: 2100,
            height: 2970,
            title: 'A4'
        }
    },
    PT_PER_PX: 0.75,
    INCHES_PER_CM,
    BROWSER_PPI: 96,
    FORM_PPI,
    FORM_PPMM: FORM_PPI / INCHES_PER_CM / 10,
    FORM_DEFAULT_FONT_SIZE: 12,
    FIELD_TAGS: [
        { name: "fname", label: 'First Name' },
        { name: "lname", label: 'Last Name' },
        { name: "gender", label: 'Gender' },
        { name: "dob", label: 'Date of Birth' },
        { name: "phone", label: 'Phone Number' },
        { name: "email", label: 'Email Address' },
        { name: "address1", label: 'Address Line 1' },
        { name: "address2", label: 'Address Line 2' },
        { name: "city", label: 'City' },
        { name: "province", label: 'Province/State' },
        { name: "postal", label: 'Postal/Zip Code' },
        { name: "custom1", label: 'Custom Tag 1' },
        { name: "custom2", label: 'Custom Tag 2' },
        { name: "custom3", label: 'Custom Tag 3' },
        { name: "custom4", label: 'Custom Tag 4' },
        { name: "custom5", label: 'Custom Tag 5' },
        { name: "custom6", label: 'Custom Tag 6' },
        { name: "custom7", label: 'Custom Tag 7' },
        { name: "custom8", label: 'Custom Tag 8' },
        { name: "custom9", label: 'Custom Tag 9' },
        { name: "custom10", label: 'Custom Tag 10' },
    ],
    ICONS: {
        FORM_DRAFT: 'far fa-file-signature',
        FORM: 'far fa-file-alt'
    },
    BREAKPOINT_MOBILE: 767,
    BREAKPOINT_TABLET: 991,
    USER_AGENT: {
        isDesktop: userAgent.platform.type === Bowser.PLATFORMS_MAP.desktop,
        isMobile: userAgent.platform.type === Bowser.PLATFORMS_MAP.mobile,
        isTablet: userAgent.platform.type === Bowser.PLATFORMS_MAP.tablet,
        os: userAgent.os.name,
        isWindows: userAgent.os.name === Bowser.OS_MAP.Windows,
        isMac: userAgent.os.name === Bowser.OS_MAP.MacOS,
        isLinux: userAgent.os.name === Bowser.OS_MAP.Linux,
        isIOS: userAgent.os.name === Bowser.OS_MAP.iOS,
        isAndroid: userAgent.os.name === Bowser.OS_MAP.Android,
        browser: userAgent.browser.name,
        browserVersion: userAgent.browser.version,
        isChrome: userAgent.browser.name === Bowser.BROWSER_MAP.chrome,
        isFirefox: userAgent.browser.name === Bowser.BROWSER_MAP.firefox,
        isSafari: userAgent.browser.name === Bowser.BROWSER_MAP.safari,
        isIE: userAgent.browser.name === Bowser.BROWSER_MAP.ie,
        isEdge: userAgent.browser.name === Bowser.BROWSER_MAP.edge,
    },
    FONT_SIZES: [6, 7, 8, 9, 10, 10.5, 11, 12, 13, 14, 16, 18, 20, 22, 24, 28, 36, 48, 72],
    LONG_DATE_FORMAT: 'mmm d, yyyy',
    LONG_DATE_TIME_FORMAT: 'dddd, mmm dd, h:MMtt',
    SELECTOR_FOCUSABLE: 'button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])',
    BLANK_PNG: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=",
    PAYMENT_PROCESSORS: {
        PAPERPAY: 'paperpay',
        MONERIS: 'moneris',
        STRIPE: 'stripe',
        PSN: 'psn'
    },
    REGION_CODES,
    DEFAULT_APP_STATUS: {
        "MAINTENANCE_MODE": false,
        "FILLER_MAINTENANCE_MODE": false,
        "APP_EXPIRE": 0  
    },
    SUBDOMAIN_MIN_LENGTH: 6,
    SUBDOMAIN_MAX_LENGTH: 20,
    LANGUAGES: [
        { title: 'English', code: 'en' },
        { title: 'French', code: 'fr' },
    ],
}

export var constants;